export const URL_CONSTANTS = {
  HOME: "/",
  WORKFORCE_SALARY: "/Workforce&Salary",
  STATE: "/State",
  STATE_AGENCIES: "/StateAgencies",
  EDUCATION: "/Education",
  COUNTY: "/Counties",
  CITY: "/City",
  LOCAL_DISTRICT: "/LocalDistrict",
  VENDOR_PAYMENTS: "/VendorPayments",
  PUBLIC_RECORD_REQUEST: "/PublicRecordRequest",
  RESOURCES: "/Resources",
  ERROR: "/Error",
};

export const EXTERNAL_SITE_LINKS = {
  MOU: "https://transparencyresources.idaho.gov/transparentidaho/Pages/StatewideAgreementsContractsDisplay.aspx",
  ANNUAL_COMPREHENSIVE_FINANCIAL_REPORT:
    "https://www.sco.idaho.gov/LivePages/annual-comprehensive-financial-reports.aspx",
  EMPLOYMENT_VERIFICATION: "https://www.experianverify.com",
  UNCASHED_WARRANTS:
    "https://stateofidaho.qualtrics.com/jfe/form/SV_cxdN5JSvNhX7nAG",
  SCHEDULE_OF_EXP_OF_FIN_REPORTS:
    "https://www.sco.idaho.gov/LivePages/scheduleofexpendituresoffedawards.aspx",
  TOWN_HALL_IDAHO: "https://townhall.idaho.gov/",
  ADDITIONAL_RECOURSES:
    "https://www.sco.idaho.gov/LivePages/TIAdditionalResources.aspx",
  FEATURED_RESOURCES: "https://youtu.be/_ePULHeku-o",
  INSIGHT_IDAHO: "https://insight.idaho.gov/",
  CENTRAL_REGISTRY:
    "https://transparencyresources.idaho.gov/transparentidaho/Pages/local-government-registry.aspx",
  TOWNFALL_IDAHO: "https://townhall.idaho.gov/",
  SURPLUS_PROPERTY:
    "https://surprop.sco.idaho.gov/Lists/Available%20Surplus%20Property/AllItems.aspx",
  NEWSPAPER_ASSOCIATION_IDAHO:
    "https://www.idahopublicnotices.com/(S(wiw2ccamc1f0f2qky4kb2lnm))/default.aspx",
  VOTE_IDHAO: "https://voteidaho.gov/",
  NEIGHBOR_TRANSPARENCY_PAGES:
    "https://www.sco.idaho.gov/LivePages/neighborstatestransparency.aspx",
  ASSOCIATED_TAXPAYERS_IDAHO: "https://www.ati-taxinfo.com/",
  DIVISION_OF_FACILITIES_MANAGEMENT: "https://dfm.idaho.gov/",
};
